import { TextSection } from "@/components/custom";
import { Button, PricingCard } from "@/components/ui";
import { pricingdata } from "../../../config/landingPageConfig.tsx";
import { RouteConstant } from "@/util/constant/RouteConstant.ts";
import { useNavigate } from "react-router-dom";
export const PricingPlans = () => {
  const navigate = useNavigate()
  const gotoLogin = () => {
    navigate(RouteConstant.auth.login.path)
  }
  return (
    <div
      id="pricing"
      className="lg:px-10 px-5 py-20 items-center justify-center flex-col flex"
    >
      <TextSection
        heading="Our Pricing Plans"
        subtext="Choose the Qoonity plan that fits your coding needs."
        className="mx-auto"
      />
      <div className=" grid grid-cols-2 w-full max-w-sm rounded-lg p-1 mt-10 justify-center items-center bg-[#1F2228] border-[#14151A0D]">
        <div className="border-[#FFFFFF2E] bg-[#14151A] w-full text-center px-2 p-2 mx-auto border rounded-lg">
          <h2>Monthly</h2>
        </div>
        <div className="text-center text-tertiary flex-row gap-2 justify-center flex items-center">
          <h2 className="">Annual</h2>
          <div className="border-[#FFFFFF2E] bg-[#FFFFFF14] text-center  inline-block px-2 p-1 border rounded-lg">
            <h1>Save 25%</h1>
          </div>
        </div>
      </div>
      <div className="flex-col lg:flex-row flex gap-10 pt-10">
        {pricingdata.map((pricing) => (
          <PricingCard
            key={pricing.title}
            title={pricing.title}
            text={pricing.text}
            buttonLabel={pricing.buttonLabel}
            feature={pricing.feature}
            iconStyle={pricing.iconStyle}
            price={pricing.price}
            buttonState={pricing.buttonState}
            cardStyle={pricing.cardStyle}
          />
        ))}
      </div>

      <div className="lg:px-20 w-full mx-auto pt-10 flex px-5">
        <div className="bg-[#1A1A1A] items-center flex flex-col space-y-5 text-center  w-full  rounded-xl p-10 lg:p-20">
          <h3 className="bg-gradient-to-r font-poppins from-[#C36659] inline-block text-transparent to-[#750505] bg-clip-text">
            Boost Your Productivity
          </h3>
          <h2 className="text-tertiary max-w-2xl font-poppins">
            Whether you’re a junior dev or a coding veteran, Qoonity
            supercharges your productivity and keeps your focus on solving the
            real problems, not rewriting the same code.
          </h2>
          <Button
            label="Try Qoonity Now!"
            state="primary"
            onClick={()=>gotoLogin()}

            className="inline-block"
          />
        </div>
      </div>
    </div>
  );
};
